import { render, staticRenderFns } from "./stepsComponent.vue?vue&type=template&id=26869e12&scoped=true&"
import script from "./stepsComponent.vue?vue&type=script&lang=js&"
export * from "./stepsComponent.vue?vue&type=script&lang=js&"
import style0 from "./stepsComponent.vue?vue&type=style&index=0&id=26869e12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26869e12",
  null
  
)

export default component.exports